










































































import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import i18n from "@/libs/i18n";
import { useCustomersStore } from "@/store/useCustomersStore";
// @ts-ignore
import { required } from "@validations";
import {
    BAlert,
    BButton,
    BCol,
    BContainer,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BLink,
    BPagination,
    BRow,
    BSpinner,
    BTab,
    BTable,
    BTabs,
} from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import ApiSettings from "./components/api.vue";
import InboxSettings from "./components/inbox.vue";
import EngageSettings from "./components/engage.vue";
import NoticeSettings from "./components/notice.vue";
import MaintenanceSettings from "./components/maintenance.vue";
import PaymentSettings from "./components/payment.vue";
import OpenAiSettings from "./components/openAi.vue";
import ContactsSettings from "./components/contacts.vue";
import ChannelSettings from "@/views/modules/settings/system/components/channels.vue";

export default {
    components: {
        ChannelSettings,
        NoticeSettings,
        BFormCheckbox,
        BContainer,
        BRow,
        BCol,
        BFormInput,
        BFormGroup,
        BButton,
        BTable,
        BDropdown,
        BDropdownItem,
        BAlert,
        BPagination,
        BTabs,
        BTab,
        BLink,
        BSpinner,
        ValidationProvider,
        ValidationObserver,
        EngageSettings,
        OpenAiSettings,
        ApiSettings,
        InboxSettings,
        ContactsSettings,
        MaintenanceSettings,
        PaymentSettings,
    },
    data() {
        return {
            required,
        };
    },
    setup() {
        const toast = useToast();

        const { customerSettings, isLoadingCustomerSettings, isSavingCustomerSettings } = storeToRefs(
            useCustomersStore()
        );

        const saveSettings = () => {
            const { saveSettings } = useCustomersStore();

            saveSettings(customerSettings.value)
                .then(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.system.card-title"),
                            text: i18n.t("settings.system.saving.success"),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.system.card-title"),
                            text: i18n.t("settings.system.saving.error"),
                            icon: "cross",
                            variant: "danger",
                        },
                    });
                });
        };

        return {
            isLoadingCustomerSettings,
            isSavingCustomerSettings,
            customerSettings,
            saveSettings,
        };
    },
};
